//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import Icon from '@components/atoms/icon/Icon';
import { SmallTooltipForIcon } from '@components/molecules/tooltip/Tooltip';

export const HarmonyAIIcon = styled(Icon).attrs({
  name: 'sparkles',
})`
  path:nth-child(1) {
    fill: #329e9b;
  }

  path:nth-child(2) {
    fill: #ffd10d;
  }

  path:nth-child(3) {
    fill: #f7911e;
  }
`;

export const DisabledHarmonyAIIcon = styled(Icon).attrs({
  name: 'sparkles',
})(
  ({ theme }) => `
  color: ${theme.colors.aliases.disabled};
`,
);

export const WhiteHarmonyAIIcon = styled(Icon).attrs({
  name: 'sparkles',
})(
  ({ theme }) => `
  color: ${theme.colors.white};
`,
);

export const PrimaryHarmonyAIIcon = styled(Icon).attrs({
  name: 'sparkles',
})(
  ({ theme }) => `
  color: ${theme.colors.aliases.primary};
`,
);

export const HarmonyAIAssistedTooltip = () => (
  <SmallTooltipForIcon
    appendTarget='body'
    content='Ranked by AI, To surface your best content first.'
    placement='top'
    target={<PrimaryHarmonyAIIcon />}
  />
);

export const BodyPrimaryHarmonyAIIcon = styled(Icon).attrs({
  name: 'sparkles',
})(
  ({ theme }) => `
  color: ${theme.colors.aliases.bodyPrimary};
`,
);
